<template>
  <div class="max-w-lg w-full mx-auto">
    <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
      <div class="mt-10 mx-auto max-w-7xl px-4 sm:mt-20 sm:px-6">
        <div class="text-left">
          <h1
            class="mb-2 text-2xl flex items-center gap-2 tracking-tight font-black text-gray-900 md:text-3xl"
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.6004 12.4999C21.6004 17.8018 17.3023 22.0999 12.0004 22.0999C6.69846 22.0999 2.40039 17.8018 2.40039 12.4999C2.40039 7.19797 6.69846 2.8999 12.0004 2.8999C17.3023 2.8999 21.6004 7.19797 21.6004 12.4999ZM12.0004 8.8999C11.5577 8.8999 11.1695 9.13896 10.9602 9.50077C10.6284 10.0744 9.89429 10.2705 9.32061 9.93863C8.74694 9.60678 8.55091 8.8727 8.88276 8.29903C9.5034 7.22612 10.6664 6.4999 12.0004 6.4999C13.9886 6.4999 15.6004 8.11168 15.6004 10.0999C15.6004 11.6674 14.5986 13.0009 13.2004 13.4951V13.6999C13.2004 14.3626 12.6631 14.8999 12.0004 14.8999C11.3377 14.8999 10.8004 14.3626 10.8004 13.6999V12.4999C10.8004 11.8372 11.3377 11.2999 12.0004 11.2999C12.6631 11.2999 13.2004 10.7626 13.2004 10.0999C13.2004 9.43716 12.6631 8.8999 12.0004 8.8999ZM12.0004 18.4999C12.6631 18.4999 13.2004 17.9626 13.2004 17.2999C13.2004 16.6372 12.6631 16.0999 12.0004 16.0999C11.3376 16.0999 10.8004 16.6372 10.8004 17.2999C10.8004 17.9626 11.3376 18.4999 12.0004 18.4999Z"
                fill="#6B7280"
              />
            </svg>

            <span class="block">Get help</span>
          </h1>
          <p class="text-base font-medium text-gray-600">
            Get help for Pamela's GraduationClip
          </p>

          <!--Hiding this section because not appear in figma-->
          <!----<h1 class="tracking-tight font-extrabold text-gray-900 text-2xl md:text-3xl mt-4 mb-2">
                        <span class="block text-mygrad">{{ clip.registration.name }}</span>
                    </h1>
                    <h2 class="tracking-tight font-extrabold text-gray-900 text-base md:text-xl">
                        <span class="block text-mygrad-light">{{ organiser.name }}</span>
                    </h2> -->
          <div
            class="mt-4 w-full bg-white shado-sm border border-[#d1d5da] px-6 py-2 overflow-hidden rounded-xl grid grid-cols-1 md:grid-cols-1 content-center"
          >
            <div
              v-for="(faq, index) in faqs"
              :key="index"
              :class="[
                'text-sm py-4 font-medium text-gray-700 bg-white transition-all duration-300 ease-in-out',
                index !== faqs.length - 1 ? 'border-b border-[#d1d5da]' : '',
              ]"
            >
              <div @click="toggleFaq(index)" class="cursor-pointer">
                <h3
                  class="text-base text-left font-extrabold text-gray-900 flex gap-2"
                >
                  <svg
                    :class="{ transform: faq.isOpen }"
                    :style="{
                      transform: faq.isOpen
                        ? 'rotate(360deg)'
                        : 'rotate(270deg)',
                    }"
                    class="w-5 h-5 transition-transform duration-300 ease-in-out"
                    style="min-width: 20px; min-height: 20px"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                  {{ index + 1 }}.
                  {{ faq.question }}
                </h3>
              </div>
              <transition
                enter-active-class="transition-all duration-300 ease-out"
                enter-from-class="opacity-0 max-h-0"
                enter-to-class="opacity-100 max-h-[500px]"
                leave-active-class="transition-all duration-300 ease-in"
                leave-from-class="opacity-100 max-h-[500px]"
                leave-to-class="opacity-0 max-h-0"
              >
                <div v-show="faq.isOpen" class="mt-2 overflow-hidden">
                  <p class="text-black text-base font-normal text-left">
                    {{ faq.answer }}
                  </p>
                  <button
                    v-if="faq.buttonText"
                    type="submit"
                    @click="faq.action"
                    class="text-center w-full mt-3 items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    <img
                      :src="require(`@/assets/${faq.icon}`)"
                      class="w-5 h-5 inline-block mr-2"
                      alt="icon"
                    />
                    {{ faq.buttonText }}
                  </button>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { trackEvent } from "../../Analytics.vue";

export default {
  name: "Help",
  props: { organiser: Object },
  data: function () {
    return {
      clip: {},
      faqs: [
        {
          question:
            "My GraduationClip needs adjusting - its too early / too late",
          answer:
            "You can adjust the timing of your GraduationClip by clicking the button below, carefully follow the instructions presented on screen!",
          buttonText: "Edit my GraduationClip",
          icon: "clip.svg",
          action: this.changeClip,
          isOpen: false,
        },
        {
          question: "The Audio is cut off on my GraduationClip",
          answer:
            "You can adjust the timing of the audio in your GraduationClip by clicking the button below, carefully follow the instructions presented on screen!",
          buttonText: "Adjust my sound",
          icon: "audio.svg",
          action: this.changeAudio,
          isOpen: false,
        },
        {
          question:
            "I made a mistake with the spelling of my name, faculty or course",
          answer:
            "You can edit your name, faculty and course by clicking on the button below - we will automatically regenerate your video afterwards.",
          buttonText: "Fix a spelling mistake",
          icon: "edit.svg",
          action: this.changeName,
          isOpen: false,
        },
      ],
    };
  },
  beforeCreate() {
    const clipId = this.$route.params.id;
    axios
      .get(`/clips/${clipId}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((response) => response.data)
      .then((response_data) => this.setData(response_data))
      .catch(
        (error) => (
          (this.error = error.response.error),
          trackEvent(this.$route.path, {
            label: "GRADUATIONCLIP_NOT_READY",
            submission_id: this.$route.params.id,
          })
        )
      );
  },
  methods: {
    setData(clip) {
      this.clip = clip;
      this.clip.submission.id = this.$route.params.id;
      trackEvent(this.$route.path, {
        label: "FAQS_PAGE_VIEW",
        registration_id: this.clip.registration.id,
        submission_id: this.$route.params.id,
      });
    },
    changeClip() {
      trackEvent(this.$route.path, {
        label: "CHANGE_CLIP_CLICK",
        registration_id: this.clip.registration.id,
        submission_id: this.$route.params.id,
      });
      this.$router.push(
        `/submission/${this.clip.registration.id}?uni=${this.organiser.slug}&timecode=${this.clip.submission.in_point}`
      );
    },
    changeAudio() {
      trackEvent(this.$route.path, {
        label: "CHANGE_AUDIO_CLICK",
        registration_id: this.clip.registration.id,
        submission_id: this.$route.params.id,
      });
      window.open(
        `/clip/${this.organiser.slug}/${this.$route.params.id}/audio`
      );
    },
    changeName() {
      trackEvent(this.$route.path, {
        label: "UPDATE_DETAILS_CLICK",
        registration_id: this.clip.registration.id,
        submission_id: this.$route.params.id,
      });
      window.open(
        `/${this.organiser.slug}/registration/${this.clip.registration.id}/update`
      );
    },
    toggleFaq(index) {
      this.faqs[index].isOpen = !this.faqs[index].isOpen;
    },
    trackEvent,
  },
  mounted() {},
  components: {},
  beforeDestroy() {},
};
</script>

<style scoped>
#shareButtons {
  display: flex;
  padding: 10px !important;
  justify-content: center !important;
  flex-wrap: wrap;
}

.a2a_default_style:not(.a2a_flex_style) a {
  margin: 4px 0;
}

.modal {
  position: absolute;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: #daf6ff;
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.modal-content {
  background-color: #daf6ff;
  margin: 15% auto;
  /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  /* Could be more or less, depending on screen size */
  border: 2px solid #08697b;
  /* Black border, you can change the color */
  border-radius: 10px;
  /* Rounded corners */
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.video-container {
  position: relative;
}
</style>
